<template>
  <div>
    <div style="display: flex; justify-content: right; margin-bottom: 10px">
      <el-button size="mini" class="searchBtn btns" type="primary" @click="onClickSure">确定</el-button>
    </div>
    <el-table ref="multipleTable" v-loading="tableLoading" :data="tableData" @select="handleSelect" @select-all="handleSelectAll" row-key="id" border style="width: 100%">
      <el-table-column type="selection" :reserve-selection="true" align="center" width="50px" />
      <!-- <el-table-column type="index" label="序号" width="80px" align="center" /> -->
      <el-table-column label="金额" align="center" prop="price" />
    </el-table>
    <div style="margin: 10px 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
    </div>
  </div>
</template>

<script>
  import { getPushList, repeal } from '@/service/account';
  export default {
    props: {
      summaryId: { type: String, default: '' },
    },
    data() {
      return {
        tableLoading: false,
        tableData: [],
        // multipleSelections: {}, // 所有选中的数据
        multipleSelection: [], // 选中的数据
        currentPage: 1,
        total: 0,
        pageSize: 10,
      };
    },
    methods: {
      async onClickSure() {
        const { status, message } = await repeal({ id: this.multipleSelection.map(row => row.id).join(',') });
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.$emit('closeCancelDialog')
      },
      handleSelect(val) {
        this.multipleSelection = val;
      },
      handleSelectAll(val) {
        this.multipleSelection = val;
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.showData();
      },
      async handleCurrentChange(val) {
        this.currentPage = val;
        this.showData();
      },
      async showData() {
        const res = await getPushList({ id: this.summaryId, page: this.currentPage, rows: this.pageSize });
        this.tableData = res.data.records;
        this.total = res.data.total;
      },
      closeSelected() {
        this.$refs.multipleTable.clearSelection();
      }
    },
  };
</script>

<style lang="scss"></style>
